import type { DesktopBridge } from "@afar-research/contracts";

export const DESKTOP_PASTE_AS_TEXT_EVENT = "afar-research:paste-as-text";

/** Arm composer paste handling before Electron delivers the native clipboard event. */
export function installDesktopPasteAsText(
  bridge:
    | (Pick<DesktopBridge, "onMenuAction"> & {
        /** Absent where the shell has no native paste-as-text command. */
        readonly pasteAsText?: () => void | Promise<void>;
      })
    | undefined,
  target: EventTarget,
): (() => void) | undefined {
  return bridge?.onMenuAction((action) => {
    if (action !== "paste-as-text") return;
    target.dispatchEvent(new Event(DESKTOP_PASTE_AS_TEXT_EVENT));
    void bridge.pasteAsText?.();
  });
}
